/**
 * HNB-479: Load lottie.js only when the page contains lottie-player elements.
 */
(function () {
  var loader = document.currentScript;
  if (!loader) {
    loader = document.querySelector('script[data-mfr-lottie-src]');
  }
  var lottieSrc = loader && loader.getAttribute('data-mfr-lottie-src');
  if (!lottieSrc) return;

  function inject() {
    if (document.querySelector('script[data-mfr-lottie-injected]')) return;
    if (!document.querySelector('lottie-player')) return;
    var s = document.createElement('script');
    s.src = lottieSrc;
    s.async = true;
    s.setAttribute('data-mfr-lottie-injected', 'true');
    document.body.appendChild(s);
  }

  if (document.querySelector('lottie-player')) {
    inject();
    return;
  }

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      if (document.querySelector('lottie-player')) {
        observer.disconnect();
        inject();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(inject, { timeout: 4000 });
    } else {
      setTimeout(inject, 500);
    }
  }

  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
